import Actions, { Action } from '@gogame/ui/Actions';
import { EditIcon, DeleteIcon } from '@gogame/ui/Icon';

const CommentActions = ({ onEdit, onDelete }) => {
  return (
    <Actions limit={0} data-cy={'commentActions'}>
      <Action id={'edit'} icon={<EditIcon />} label={'Edit'} onClick={onEdit} />
      <Action
        id={'delete'}
        icon={<DeleteIcon />}
        label={'Delete'}
        onClick={onDelete}
      />
    </Actions>
  );
};
export default CommentActions;
